import { FlowDurationUnits, FlowFhirResourceType, FlowHieDocumentFormat } from 'flow-schema';
import { z } from 'zod';

import { oneOrMany } from '../../../utils.js';
import {
  BaseFlowBlockSchema,
  BlockType,
  DurationSchemaWithMax,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const BaseHieGetDocumentsBlockConfigSchema = z.object({
  sourceBlock: z.object({
    sourceBlockName: z.string(),
  }),
  timeout: DurationSchemaWithMax('timeout', {
    value: 30,
    units: FlowDurationUnits.Minutes,
  }),
});

export const BaseConsolidatedBlockConfigSchema = BaseHieGetDocumentsBlockConfigSchema.extend({
  resources: oneOrMany(z.enum(FlowFhirResourceType)).default([]),
  dateTo: z.string().optional(),
  dateFrom: z.string().optional(),
});

export const ConsolidatedJsonConfigSchema = BaseConsolidatedBlockConfigSchema.extend({
  documentFormat: z.enum([FlowHieDocumentFormat.ConsolidatedData]),
  includeRelatedRecords: z.boolean().default(false),
});

export type ConsolidatedJsonConfig = z.infer<typeof ConsolidatedJsonConfigSchema>;

export const ConsolidatedRenderedConfigSchema = BaseConsolidatedBlockConfigSchema.extend({
  documentFormat: z.enum([
    FlowHieDocumentFormat.ConsolidatedDataPdf,
    FlowHieDocumentFormat.ConsolidatedDataHtml,
  ]),
});

export const BulkDownloadUrlsConfigSchema = BaseHieGetDocumentsBlockConfigSchema.extend({
  documentFormat: z.literal(FlowHieDocumentFormat.BulkDownloadUrls),
});

export const HieGetDocumentsBlockConfigSchema = z.discriminatedUnion('documentFormat', [
  ConsolidatedJsonConfigSchema,
  ConsolidatedRenderedConfigSchema,
  BulkDownloadUrlsConfigSchema,
]);

export type HieGetDocumentsBlockConfig = z.infer<typeof HieGetDocumentsBlockConfigSchema>;

export const HieGetDocumentsBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.HieGetDocuments),
  config: HieGetDocumentsBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.Any),
});

export type HieGetDocumentsBlock = z.infer<typeof HieGetDocumentsBlockSchema>;
